import { FC } from 'react';
import BottomBarWrapper from '@campaigns/src/components/bottom-bar/BottomBarWrapper';
import { Button, Icon } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
  previousUrl?: string;
  backText?: string;
}

const FlowProductsBottomBar: FC<Props> = ({ previousUrl, backText }) => {
  const { t } = useTranslation();

  return (
    <BottomBarWrapper>
      {previousUrl && (
        <Button
          flexShrink={0}
          as={Link}
          to={previousUrl}
          leftIcon={<Icon name="GeneralActionsArrowLeft" />}
          variant="white"
        >
          {backText}
        </Button>
      )}
      <Button
        flexShrink={0}
        ml="auto"
        onClick={() => null}
        isDisabled={true}
        rightIcon={<Icon name="GeneralActionsArrowRight" />}
      >
        {t('CAMPAIGNS_DETAIL-CHOSEN_PRODUCTS')}
      </Button>
    </BottomBarWrapper>
  );
};

export default FlowProductsBottomBar;
